import React, { useState, useEffect } from 'react';
import axios from 'axios';
import config from '../config';
// Configuración de notificaciones eliminada

function Configuracion() {
  const [configuraciones, setConfiguraciones] = useState([]);
  const [tarifas, setTarifas] = useState({
    '30_minutes': { precio: 0, descripcion: 'Sesión de 30 minutos' },
    '45_minutes': { precio: 0, descripcion: 'Sesión de 45 minutos' },
    'pack_4_sessions': { precio: 0, descripcion: 'Pack de 4 sesiones mensuales' }
  });
  const [mensaje, setMensaje] = useState('');
  const [cargando, setCargando] = useState(false);

  const cargarConfiguracion = async () => {
    try {
      const token = localStorage.getItem(config.tokenKey);
      
      // Cargar configuraciones generales
      const configRes = await axios.get(`${config.apiUrl}/configuracion`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      setConfiguraciones(configRes.data);

      // Cargar tarifas
      const tarifasRes = await axios.get(`${config.apiUrl}/tarifas`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      const tarifasData = {};
      tarifasRes.data.forEach(tarifa => {
        tarifasData[tarifa.tipo_sesion] = {
          precio: tarifa.precio,
          descripcion: tarifa.descripcion
        };
      });
      setTarifas(prev => ({ ...prev, ...tarifasData }));
    } catch (error) {
      console.error('Error cargando configuración:', error);
      setMensaje('Error al cargar la configuración');
    }
  };

  useEffect(() => {
    cargarConfiguracion();
  }, []);

  const handleCambio = (clave, nuevoValor) => {
    setConfiguraciones(prev => 
      prev.map(config => 
        config.clave === clave ? { ...config, valor: nuevoValor } : config
      )
    );
  };

  const handleCambioTarifa = (tipoSesion, campo, valor) => {
    setTarifas(prev => ({
      ...prev,
      [tipoSesion]: {
        ...prev[tipoSesion],
        [campo]: campo === 'precio' ? parseFloat(valor) || 0 : valor
      }
    }));
  };

  const guardarConfiguracion = async () => {
    setCargando(true);
    setMensaje('');
    
    try {
      const token = localStorage.getItem(config.tokenKey);
      
      // Guardar configuraciones generales
      await axios.put(`${config.apiUrl}/configuracion`, configuraciones, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      // Guardar tarifas
      for (const [tipoSesion, datos] of Object.entries(tarifas)) {
        await axios.put(`${config.apiUrl}/tarifas/${tipoSesion}`, datos, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
      }

      setMensaje('✅ Configuración guardada correctamente');
      
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (error) {
      console.error('Error guardando configuración:', error);
      setMensaje('❌ Error al guardar la configuración');
    } finally {
      setCargando(false);
    }
  };

  const restablecerValores = () => {
    if (window.confirm('¿Estás seguro de que deseas restablecer los valores por defecto?')) {
      setConfiguraciones(prev => prev.map(config => {
        let valorPorDefecto = '';
        switch(config.clave) {
          case 'costo_sesion_30min':
            valorPorDefecto = '40';
            break;
          case 'costo_sesion_45min':
            valorPorDefecto = '50';
            break;
          case 'recordatorio_automatico':
            valorPorDefecto = '24';
            break;
          case 'email_notificaciones':
            valorPorDefecto = '1';
            break;
          default:
            valorPorDefecto = config.valor;
        }
        return { ...config, valor: valorPorDefecto };
      }));

      // Restablecer tarifas
      setTarifas({
        '30_minutes': { precio: 40, descripcion: 'Sesión de 30 minutos' },
        '45_minutes': { precio: 50, descripcion: 'Sesión de 45 minutos' },
        'pack_4_sessions': { precio: 180, descripcion: 'Pack de 4 sesiones mensuales' }
      });
    }
  };

  const renderCampoConfiguracion = (config) => {
    switch(config.tipo) {
      case 'number':
        return (
          <input
            type="number"
            value={config.valor}
            onChange={(e) => handleCambio(config.clave, e.target.value)}
            className="campo-configuracion"
            step="any"
            min="0"
          />
        );
      case 'boolean':
        return (
          <select
            value={config.valor}
            onChange={(e) => handleCambio(config.clave, e.target.value)}
            className="campo-configuracion"
          >
            <option value="1">Activado</option>
            <option value="0">Desactivado</option>
          </select>
        );
      default:
        return (
          <input
            type="text"
            value={config.valor}
            onChange={(e) => handleCambio(config.clave, e.target.value)}
            className="campo-configuracion"
          />
        );
    }
  };

  return (
    <div className="configuracion-page">
      <div className="page-header">
        <h2>Configuración del Sistema</h2>
        <div className="acciones-configuracion">
          <button 
            className="btn-secondary"
            onClick={restablecerValores}
            disabled={cargando}
          >
            🔄 Restablecer
          </button>
          <button 
            className="btn-primary"
            onClick={guardarConfiguracion}
            disabled={cargando}
          >
            {cargando ? '💾 Guardando...' : '💾 Guardar Cambios'}
          </button>
        </div>
      </div>

      {mensaje && (
        <div className={`mensaje ${mensaje.includes('✅') ? 'mensaje-exito' : 'mensaje-error'}`}>
          {mensaje}
        </div>
      )}

      <div className="configuracion-grid">
        {configuraciones.map(config => (
          <div key={config.clave} className="configuracion-card">
            <div className="configuracion-info">
              <h3>
                {config.clave === 'costo_sesion_30min' && '💰'}
                {config.clave === 'costo_sesion_45min' && '💰'}
                {config.clave === 'recordatorio_automatico' && '⏰'}
                {config.clave === 'email_notificaciones' && '📧'}
                {' '}{config.descripcion}
              </h3>
              <p className="clave-configuracion">Clave: {config.clave}</p>
            </div>
            <div className="configuracion-control">
              {renderCampoConfiguracion(config)}
            </div>
          </div>
        ))}
      </div>

      <div className="page-header" style={{ marginTop: '30px' }}>
        <h2>💰 Tarifas de Sesiones</h2>
      </div>

      <div className="configuracion-grid">
        <div className="configuracion-card">
          <div className="configuracion-info">
            <h3>💰 Sesión de 30 minutos</h3>
            <p className="clave-configuracion">Tipo: 30_minutes</p>
          </div>
          <div className="configuracion-control">
            <input
              type="number"
              value={tarifas['30_minutes'].precio}
              onChange={(e) => handleCambioTarifa('30_minutes', 'precio', e.target.value)}
              className="campo-configuracion"
              step="0.01"
              min="0"
              placeholder="Precio"
            />
            <input
              type="text"
              value={tarifas['30_minutes'].descripcion}
              onChange={(e) => handleCambioTarifa('30_minutes', 'descripcion', e.target.value)}
              className="campo-configuracion"
              style={{ marginTop: '10px' }}
              placeholder="Descripción"
            />
          </div>
        </div>

        <div className="configuracion-card">
          <div className="configuracion-info">
            <h3>💰 Sesión de 45 minutos</h3>
            <p className="clave-configuracion">Tipo: 45_minutes</p>
          </div>
          <div className="configuracion-control">
            <input
              type="number"
              value={tarifas['45_minutes'].precio}
              onChange={(e) => handleCambioTarifa('45_minutes', 'precio', e.target.value)}
              className="campo-configuracion"
              step="0.01"
              min="0"
              placeholder="Precio"
            />
            <input
              type="text"
              value={tarifas['45_minutes'].descripcion}
              onChange={(e) => handleCambioTarifa('45_minutes', 'descripcion', e.target.value)}
              className="campo-configuracion"
              style={{ marginTop: '10px' }}
              placeholder="Descripción"
            />
          </div>
        </div>

        <div className="configuracion-card">
          <div className="configuracion-info">
            <h3>📦 Pack de 4 sesiones</h3>
            <p className="clave-configuracion">Tipo: pack_4_sessions</p>
          </div>
          <div className="configuracion-control">
            <input
              type="number"
              value={tarifas['pack_4_sessions'].precio}
              onChange={(e) => handleCambioTarifa('pack_4_sessions', 'precio', e.target.value)}
              className="campo-configuracion"
              step="0.01"
              min="0"
              placeholder="Precio"
            />
            <input
              type="text"
              value={tarifas['pack_4_sessions'].descripcion}
              onChange={(e) => handleCambioTarifa('pack_4_sessions', 'descripcion', e.target.value)}
              className="campo-configuracion"
              style={{ marginTop: '10px' }}
              placeholder="Descripción (ej: Pack mensual con descuento)"
            />
          </div>
        </div>
      </div>

      <div className="configuracion-info-adicional">
        <h3>💡 Información Importante</h3>
        <ul>
          <li>Los cambios en los costos de sesión afectarán los cálculos de ingresos estimados</li>
          <li>Los recordatorios se envían automáticamente según la configuración establecida</li>
          <li>Las tarifas se aplicarán al registrar nuevos pagos</li>
          <li>El pack de 4 sesiones puede tener un precio con descuento</li>
          <li>La aplicación se recargará automáticamente después de guardar los cambios</li>
        </ul>
      </div>

      {/* Se eliminó la configuración de notificaciones */}
    </div>
  );
}

export default Configuracion;
